<template>
  <div class="modal">
    <div class="mask"></div>
    <div :class="fit ? 'fit-content contenido-modal' : 'contenido-modal'">
      <div v-if="showMovilHeader" class="movil-header">
        <button @click="closeModal" type="button" class="btn-close"></button>
      </div>
      <div v-if="showHeader" class="modal-header">
        <!-- <img  alt="logo" /> -->
        <span>{{ header }}</span>
        <button @click="closeModal" type="button" class="btn-close"></button>
      </div>
      <div class="linea" v-if="linea"></div>
      <div :class="cuerpoModal" class="cuerpo-modal">
        <slot />
      </div>
      <div v-if="footer" class="modal-footer">
        <div class="modal-btn-container">
          <p @click="closeModal" class="btn-cierre">Cerrar</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetalleOrden",
  components: {},
  props: {
    header: {
      type: String,
      default: "Detalle de la orden",
    },
    showMovilHeader:{
      type:Boolean,
      default:false
    },
    showHeader:{
      type:Boolean,
      default:true
    },
    fit: {
      type: Boolean,
      default: false,
    },
    cuerpoModal:{
      type:String,
      default:""
    },
    linea: {
      type: Boolean,
      default: true,
    },
    footer: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["closeModal"],
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.solo {
  width: 179px;
  background-position-x: 40px;
  background-position-y: 8px;
  background-size: 18px;
}

.boton-cancelar:hover {
  color: #fff;
  background-color: #4873d3;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
}

.btn-cierre {
  font: normal normal bold 16px/22px Open Sans;
  color: #4caf50;
  padding-right: 26px;
  cursor: pointer;
}

/* .background-mobile {
    background-color: #4873d3;
    width: 100%;
    min-height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-shadow: 0px 2px 5px #0000004f;
    border-radius: 0px 0px 5px 5px;
  } */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  /* padding-top: 100px; */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.mask {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.contenido-modal {
  position: relative;
  background-color: #ffffff;
  margin: auto;
  border-radius: 10px;
  min-width: 320px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  box-sizing: border-box;
  z-index: 1000;
  /* padding: 18px 0px; */
  /* width: 388px; */
  width: 100%;
  height: 100%;
}
.modal-header {
  text-align: center;
  /* color: #4873D3; */
  border-radius: 6px 6px 0 0;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  /* border-bottom: 1px solid #707070; */
}
.modal-header span {
  flex: 1;
  font-weight: 600;
  text-align: left;
  font: normal normal bold 18px/27px Open Sans;
  letter-spacing: 0px;
  color: #4873d3;
  opacity: 1;
  margin-top: 10px;
}
.modal-header img {
  width: 33px;
  justify-content: center;
  margin-top: 10px;
  margin-right: 10px;
}

.linea {
  /* top: 537px;
      left: 21px; */
  width: 95%;
  height: 2px;
  border: 1px solid #707070;
  opacity: 0.39;
  margin: auto;
  margin-top: 14px;
  margin-bottom: 0px;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.4em;
  color: #000;
  background: url("../../assets/imgs/cerrar_azul.svg") center/1rem auto
    no-repeat;
  background-color: transparent;
  filter: grayscale(1);
  opacity: 0.6;
  border: 0;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
  margin-left: auto;
  margin-top: 10px;
}

.btn-close:hover {
  background-color: #4873d3;
  cursor: pointer;
}
.contenido-modal .close {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
  margin-top: -10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.contenido-modal .close:hover {
  background-color: #f2f2f2;
  transition: 0.3s;
}
.contenido-modal .cuerpo-modal {
  overflow-y: auto;
  padding: 0px 26px;
}
.contenido-modal .cuerpo-modal.overflow {
  overflow-y: visible;
  padding: 0px 26px;
}
.cuerpo-modal .contenedor-status {
  text-align: left;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
}
.cuerpo-modal .contenedor-item {
  width: 100%;
  /* height: 21px; */
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font: normal normal normal 14px/19px Open Sans;
}

@-webkit-keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@media (min-width: 767px) {
  .modal {
    padding: 20px;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .contenido-modal .cuerpo-modal {
    padding: 13px 26px;
  }
  .contenido-modal {
    height: min-content;
    min-width: 500px;
    min-height: 500px;
    max-width: 800px;
    /* width: 401px; */
  }

  .fit-content {
    height: min-content;
    min-width: 300px;
    min-height: min-content !important;
    max-width: fit-content !important;
    /* width: 401px; */
  }

  .movil-header{
    display: none;
  }
}

@media (max-width: 1279px) {
  .contenido-modal {
    /*height: 100vh;*/
    min-height: 400px;
    width: min-content;
    /*max-height: 530px;*/
    border-radius: 6px;
    padding: 0;
    box-shadow: 0px 3px 6px #3d424bb2;
  }
}

@media (max-width: 767px) {

  .movil-header{
    width: 100%;
    height: 60px;
    background-color: #0A4F9C;
    position: relative;
  }

  .movil-header .btn-close{
    position: absolute;
    top: 4px;
    right: 10px;
    filter: brightness(0) invert(1);
  }
  .movil-header .btn-close:hover{
   filter: none;
   background-color: #fff;
  }
  .modal-header {
    margin-bottom: 10px;
  }

  .modal-header span {
    font: normal normal bold 14px/27px Open Sans;
  }

  .contenido-modal {
    height: min-content;
    width: fit-content;
    min-height: 300px;
    max-width: 98%;
  }
}


</style>
